import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import DownloadPage, { getDefaultPageData } from "components/pages/DownloadPage";
import Classes, { Account } from "model";

/**
 * @function CaptureDownloadsAccountSelected
 * @return {React.Component}
 * @exported true
 * @description A capture component in capture group "Download to QuickBooks".
 */
export default function CaptureDownloadsAccountSelected(props) {
    const bcmsContext = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, bcmsContext);
    const selectedAccount = Account.getDefaultBrandedAccountByType("checking");

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "selectedAccount" ], selectedAccount)
    .submit();

    return <DownloadPage data={ data } />;
}